"use strict";

exports.__esModule = true;
exports.PLUGIN_KEY = exports.BasePlugin = void 0;
var _base = require("./base");
exports.PLUGIN_KEY = _base.PLUGIN_KEY;
exports.BasePlugin = _base.BasePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/base/index.js
// module id = 56
// module chunks = 0